import { GlobalState } from '@dealstack/frontend/shared/mechanism/redux/reducers/global/global';
import { UserState } from '@dealstack/frontend/shared/mechanism/redux/reducers/user/user';

// ???
export type CommonReduxState = {
	global: GlobalState;
	user: UserState;
};

export type GlobalConfig = Window['dsConfig'];

export function getGlobalConfig(): GlobalConfig {
	return window.dsConfig;
}

export const useGlobalConfig = getGlobalConfig;
